import { LinkResultCardAction, ResultCardAction } from 'features/dynamic-tariff/components/quiz/types'

/**
 * Check if the action is a link or a button
 * @param {ResultCardAction} action
 * @returns {boolean}
 */
export const checkIsLink = (action: ResultCardAction): action is LinkResultCardAction => {
  return !!(action.externalUrl || action.internalRoute)
}
